export default __webpack_public_path__ + "static/adafruit_io_logo-3d30f3c53105e7281fb139c12e3026e0.svg";